import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

const PROMOTION_KEY = [
  { prop: 'proCode', label: '促销编号', width: '160' },
  { prop: 'proName', label: '活动名称', width: '240', tooltip: true },
  { prop: 'actStartTime', label: '活动期间', width: '300', tooltip: true },
];

const NEW_PROMOTION_KEY = [
  { prop: 'opId', label: '活动编号', width: '120' },
  { prop: 'customName', label: '自定义活动名称', width: '120', tooltip: true },
  { prop: 'code', label: '促销编号', width: '120', tooltip: true },
  { prop: 'name', label: '活动名称', width: '120', tooltip: true },
  { prop: 'time', label: '活动时间', width: '240', tooltip: true },
  { prop: 'upTime', label: '上架时间', width: '150', tooltip: true },
];

@DialogFactory
@Component({
  mixins: [style],
})
export default class PromotionLink extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '促销列表';

  width = '800px';

  curPage = '1';

  cancelText = '关闭';

  mounted() {
    this.getDataList();
  }

  getDataList() {
    this.dataList = [];
    const service = this.curPage === '1' ? 'getPromotionList' : 'getProActList';
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      pageNum: this.pageSize,
      keyword: this.keyword,
      siteCodes: this.siteCodes,
    };
    this.curPage === '1' && (postParams['status'] = 6);
    IPSService[service]({ postParams }).then((response) => {
      this.total = response.count;
      this.dataList = response.list.map((v) => {
        if (this.curPage === '1') {
          v.time = `${Functions.timeFormatSec(v.startTime)}~${Functions.timeFormatSec(v.endTime)}`;
          v.upTime = Functions.timeFormatSec(v.beforeBeginTime);
        }

        if (this.curPage === '2') {
          v.startTime = Functions.timeFormat(v.startTime);
        }
        return v;
      });
    });
  }

  onSwitch(val) {
    this.page = 1;
    this.pageSize = 10;
    this.total = 0;
    this.keyword = '';
    this.curPage = val;
    this.getDataList();
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  onSelect(id, name) {
    this.$emit('result', { id, name, linkType: this.curPage === '1' ? 10 : 8 });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  renderContent(h) {
    const mapKeys = this.curPage === '1' ? NEW_PROMOTION_KEY : PROMOTION_KEY;
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword}></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-menu default-active={this.curPage} mode="horizontal" onSelect={val => this.onSwitch(val)}>
          <el-menu-item index={'1'}>促销活动</el-menu-item>
          <el-menu-item index={'2'}>原促销活动</el-menu-item>
        </el-menu>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          {mapKeys.map((v) => {
            return <el-table-column prop={v.prop} label={v.label} show-overflow-tooltip={v.tooltip} align="center" width={v.width}></el-table-column>;
          })}
          <el-table-column
            label="操作"
            width="80px"
            fixed="right"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, this.curPage === '1' ? scope.row.opId : scope.row.proCode, this.curPage === '1' ? scope.row.customName : scope.row.proName)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
